import { Goal } from './goal';

export const MOCKGOALS: Goal[] = [
  {
    title: 'Affordable and clean energy',
    icon: 'fa fa-sun-o',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-7.png',
    category: 'direct',
    today: 'Husqvarna products are battery driven',
    tomorrow: 'Husqvarna products will run on electricity and solar energy',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Industry, innovation and infrastructure',
    icon: 'fa fa-industry',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-9.png',
    category: 'catalyst',
    today: 'Husqvarna contributes to research and science within company product lines',
    tomorrow: 'Husqvarna will work with startups to ensure new industry developments are introduced more speedily.',
    next: '',
    partner: false,
    partnerName: ''
  }, {
    title: 'Sustainable cities and communities',
    icon: 'fa fa-hospital-o',
    image: 'http://spring.myrberginnovation.se/assets/img/development-goal-11.png',
    category: 'non-applicable',
    today: 'Husqvarna is offering products to communities and cities',
    tomorrow: 'Husqvarna will take an active part in creating products to ensure sunstainability',
    next: '',
    partner: false,
    partnerName: ''
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/sustainability-goals/goals/mock-goals.ts